import { Button, Modal, Popconfirm, Result, Tooltip } from "antd";
import moment from "moment";
import React, { useState } from "react";
import { CiEdit, CiSquarePlus } from "react-icons/ci";
import { Link, useNavigate, useParams } from "react-router-dom";
import ViewAmmafos from "../../Tickets/firms/Ammafos/ViewAmmafos";
import { OneCustomer } from "../../../Stores/Customers/OneCustomer";
import { TbEyeEdit } from "react-icons/tb";
import CustomerActions from "../../../Components/Customers/CustomerActions";
import { GoCommentDiscussion } from "react-icons/go";
import { LuPenLine } from "react-icons/lu";
import { IoPersonAddOutline, IoPersonRemoveOutline } from "react-icons/io5";
import { MdOutlineUnarchive } from "react-icons/md";
import axiosInstance from "../../../Components/axiosInstance/AxiosInstance";
import { IoMdWarning } from "react-icons/io";

export default function Ticketlar({ customerDoc }) {
  const { data, loading, error, fetchData } = OneCustomer();
  let navigate = useNavigate();
  let [editModalOpen, setEditModalOpen] = useState(false);
  let [colorModalOpen, setColorModalOpen] = useState(false);
  let [open, setOpen] = useState(false);
  let [atkazData, setAtkazData] = useState(null);
  const params = useParams();
  let atkazTiket = async (id) => {
    try {
      let { data: info } = await axiosInstance.post(
        "/api/chiqim-official/ammafos-kaliy/connection",
        {
          customer_id: null,
          id: [id],
        }
      );
      console.log(info);
      fetchData(params?.id);
      setOpen(false);
    } catch (error) {
      console.log(error);
    }
  };
  let atkazTiketChirchiq = async (id) => {
    try {
      let { data: info } = await axiosInstance.post(
        "/api/chiqim-official/chirchiq/connection",
        {
          customer_id: null,
          id: [id],
        }
      );
      console.log(info);
      fetchData(params?.id);
      setOpen(false);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="flex flex-col gap-2 py-2">
      <Modal
        // style={{ top: "10px" }}
        title="Tiketni Atkaz qilish!"
        open={open}
        //   loading={loadVagon}
        onOk={() => {
          setOpen(false);
        }}
        onCancel={() => {
          console.log("Modal closed via Cancel button or close icon.");
          setOpen(false);
          setAtkazData(null);
        }}
        footer={[]}
      >
        <div className="flex flex-col items-center gap-2 justify-center">
          <div>
            <IoMdWarning className="text-[50px] text-[yellow]" />
          </div>
          <h2 className="text-center text-[18px] ">
            {atkazData?.name}ga qarashli {atkazData?.product} mahsulotli{" "}
            {atkazData?.tonna} tnli tiketni atkaz qilasizmi ?
          </h2>
          <Button
            onClick={() => {
              // setOpen(false);
              console.log(atkazData);
              let tiket_id = atkazData?.id?.split("/")[1];
              let zavod_id = atkazData?.id?.split("/")[0];
              if (Number(zavod_id) == 2) {
                atkazTiket(tiket_id);
              } else {
                atkazTiketChirchiq(tiket_id);
              }
            }}
            color="danger"
            variant="solid"
          >
            ATkaz qilish
          </Button>
        </div>
      </Modal>
      <table
        style={{
          borderCollapse: "collapse",
          width: "100%",
        }}
        border="1"
        className="text-[14px]"
        cellpadding="10"
      >
        <tr>
          <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2 border border-gray-400 px-4 py-2">
            №
          </th>
          <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
            номи
          </th>
          {/* <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
            Ўлчов бирлиги
          </th> */}
          <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
            Юк номи
          </th>
          <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
            {" "}
            Соф огирлик
          </th>
          <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
            {" "}
            Sana
          </th>
          <th className="text-[14px] text-left text-bold border border-gray-400 px-4 py-2">
            Izoh
          </th>
        </tr>
        {data?.ticket
          ?.sort(
            (a, b) =>
              moment(a.date, "YYYY-MM-DD") - moment(b.date, "YYYY-MM-DD")
          )
          ?.map((ticket) => {
            return (
              <tr>
                <td
                  onClick={() => {
                    setEditModalOpen(true);
                  }}
                  className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1 cursor-pointer"
                >
                  {/* <Link to={"/tickets/" + ticket?.id?.split("/")[1]}> */}
                  {ticket?.id?.split("/")[1]}
                  {/* </Link> */}
                </td>
                <ViewAmmafos
                  getData={() => {}}
                  isModalOpen={editModalOpen}
                  setIsModalOpen={setEditModalOpen}
                  id={ticket?.id?.split("/")[1]}
                />
                <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1">
                  <Link
                    className="text-[14px]"
                    to={"/customers/" + ticket?.customer_id}
                  >
                    {ticket?.name}
                  </Link>
                </td>
                {/* <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1">
                Tn
              </td> */}
                <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1">
                  {ticket?.product}
                </td>
                <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1">
                  {ticket?.tonna} Tn
                </td>
                <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1">
                  {moment(ticket?.date).format("YYYY-MM-DD")}
                </td>

                <td className="text-[14px] text-left text-bold border border-gray-400 px-4 py-1">
                  <CustomerActions
                    actions={[
                      {
                        type: "group",
                        key: "info",
                        label: (
                          <div
                            className=" block w-[100%] flex items-center justify-start gap-2 "
                            rel="noopener noreferrer"
                          >
                            <TbEyeEdit className="font-[18px]" />
                            <span className="text-[18px]">
                              {ticket?.created_at?.split("T")[0]}{" "}
                              {ticket?.created_at?.split("T")[1].split(".")[0]}
                            </span>
                          </div>
                        ),
                      },

                      {
                        type: "group",
                        key: "info",
                        label: (
                          <div
                            className=" block w-[100%] flex items-center justify-start gap-2 "
                            rel="noopener noreferrer"
                          >
                            <IoPersonAddOutline className="font-[18px]" />{" "}
                            <span className="text-[18px]">
                              {ticket?.written_by}{" "}
                            </span>
                          </div>
                        ),
                      },

                      {
                        type: "divider",
                      },
                      {
                        key: "6",
                        // disabled: true,
                        label: (
                          <div
                            className=" block w-[100%] flex items-center justify-start gap-2 "
                            rel="noopener noreferrer"
                            onClick={() => {}}
                          >
                            <MdOutlineUnarchive className="font-[30px]" />
                            Arxivlash
                          </div>
                        ),
                      },

                      {
                        type: "divider",
                      },
                      {
                        type: "group",
                        key: "info",
                        label: (
                          <div
                            className=" block w-[100%] flex items-center justify-start gap-2 "
                            rel="noopener noreferrer"
                          >
                            <GoCommentDiscussion className="font-[18px]" />
                            {ticket?.comment}
                          </div>
                        ),
                      },
                      {
                        type: "divider",
                      },
                      {
                        key: "7",
                        // disabled: true,
                        label: (
                          <div
                            className=" block w-[100%] flex items-center justify-start gap-2 "
                            rel="noopener noreferrer"
                            onClick={() => {
                              setAtkazData(ticket);
                              setOpen(true);
                            }}
                          >
                            <IoPersonRemoveOutline className="font-[30px]" />
                            Atkaz
                          </div>
                        ),
                      },
                    ]}
                  />
                </td>
              </tr>
            );
          })}
      </table>
    </div>
  );
}
